import { Grid } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { SetupLabel, SetupSwitch, SetupTitle } from '../../shared';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import useIntl from '../../../../../../hooks/useIntl';
import SetupGridItem from '../../../../SetupGridItem';

type ManagementFeeValues = {
  nonContinuousEnabled: boolean,
  remoteLocationEnabled: boolean,
  troubledOrCriticalEnabled: boolean,
};

type Props = {
  editMode: boolean,
  onChange: Function,
  values: ManagementFeeValues,
};

const ManagementFee = ({ editMode, onChange, values }: Props) => {
  const intl = useIntl();

  return (
    <Grid container spacing={2}>
      <SetupTitle
        GridProps={{
          sx: {
            display: 'flex',
            flexDirection: 'row',
          },
        }}
        TooltipProps={{
          title: intl.formatMessage(messages.titleTooltip),
          placement: 'top',
          containerSX: {
            marginLeft: '12px',
          },
        }}
      >
        <FormattedMessage {...messages.title} />
      </SetupTitle>
      <Grid item xs={12} sm={6}>
        <SetupLabel {...messages.nonContinuousParcelsLabel} />
        <SetupSwitch
          editMode={editMode}
          switchId="managementFee-nonContinuousParcels-switch"
          name="setup.RDNonContinuousParcelsEnabled"
          value={values?.nonContinuousEnabled}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SetupLabel {...messages.propertiesInRemoteLabel} />
        <SetupSwitch
          editMode={editMode}
          switchId="managementFee-propertiesInRemote-switch"
          name="setup.RDRemoteLocationEnabled"
          value={values?.remoteLocationEnabled}
          onChange={onChange}
        />
      </Grid>
      <SetupGridItem
        label={<FormattedMessage {...messages.troubledOrCriticalLabel} />}
        TooltipProps={{
          title: intl.formatMessage(messages.troubledOrCriticalTooltip),
        }}
      >
        <SetupSwitch
          editMode={editMode}
          switchId="managementFee-troubledOrCritical-switch"
          name="setup.RDTroubledOrCritical"
          value={values?.troubledOrCriticalEnabled}
          onChange={onChange}
        />
      </SetupGridItem>
    </Grid>
  );
};

export default ManagementFee;
